import {Inject, Injectable} from 'ng-metadata/core';
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {JwtUtilService} from "../../jwtUtil.service";
import {StorageUtil} from "../../../infra/storageUtil.service";
import {getVid} from "../../../appConfig/appConfigForward";
import {UNION_CATALOG_FAVORITE_STORAGE_KEY, UserSessionManagerService} from "../../userSessionManager.service";
import {MappingTablesCache} from "../../../mappingTablesCache/mappingTablesCache.service";


const _clone = require('lodash/clone');
const get = require('lodash/get');

@Injectable()
export class UnionCatalogLoginService {
    constructor(private userSessionManagerService : UserSessionManagerService,
                @Inject('$state') private $state : ng.ui.IStateService,
                @Inject('$window') private $window: ng.IWindowService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private jwtUtilService: JwtUtilService,
                private storageUtil: StorageUtil,
                private mappingTablesCache: MappingTablesCache){

    }
    public async goToInstitutionLogin(institutionDetails: any, state: object) {
        let instCode = institutionDetails.code;
        let toParams = get(state, 'toParams', _clone(this.$state.params)) ;
        let toState  =  get(state, 'toState', this.$state.current.name ) ;
        if (typeof toState === 'object' && toState['name']){
            toState  = toState['name'];
        }
        let institutionVid = toParams.vid.replace(/.*:/, instCode + ':') ;

        toParams.vid = institutionVid;
        let href = this.$state.href(STATE_NAMES.LOGIN, {
                vid: institutionVid, lang: toParams.lang, unionCatalogNZVid: getVid(),
                toState: toState , toParams: JSON.stringify(toParams)
            });
       
        let user = this.jwtUtilService.getDecodedToken().user;
        let favorites  = await this.userSessionManagerService.createOrGetUserArea(user);
        this.storageUtil.sessionStorage.setItem(UNION_CATALOG_FAVORITE_STORAGE_KEY, JSON.stringify(favorites));
        this.$window.location.assign(href); //we need to use location assign because changing a vid requires a bootstrap of the app

    }

    public isUnionCatalogLogin(){
        return this.userSessionManagerService.isUnionCatalogLogin();
    }

    public returnToUnionCatalogNZView() {
        let params = JSON.parse(this.$stateParams.toParams);
        params.vid = this.$stateParams.unionCatalogNZVid;
        let href = this.$state.href(this.getSavedState(), params);
        this.$window.location.assign(href);
    }

    public getSavedState(){
        let toState = this.$stateParams.toState;
        if(toState === 'openurl'){
            return 'servicesPage';
        }
        else if (toState === 'search') {
            return STATE_NAMES.SEARCH;
        }
        else if (toState === 'favorites') {
            return STATE_NAMES.FAVORITES;
        }
        else if(toState === 'jsearch') {
            return STATE_NAMES.JOURNAL_SEARCH;
        }
        else if(toState === 'dbsearch'){
            return STATE_NAMES.DB_SEARCH;
        }
        else if(toState === 'orgList'){
            return STATE_NAMES.ORGANIZATION_LIST;
        }
        else if(toState === 'npsearch'){
            return STATE_NAMES.NEWSPAPERS;
        }
        else if(toState === 'authsearch'){
            return STATE_NAMES.AUTHORITY_SEARCH;
        }
        return STATE_NAMES.SEARCH;
    }

    public getMemberInstitutionList() {
        let consortiaMembersTable = this.mappingTablesCache.getTable('consortia member codes');
        return consortiaMembersTable.map((memberRow)=>{
            let institutionName = this.$translate.instant('my_account.institution'+'.'+memberRow.target);
            return {name:institutionName, code: memberRow.target, consortiaMemberInstitutionName: memberRow.source2}
        ;});
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/unionCatalogLogin/unionCatalogLogin.service.ts